import type { Entity } from '@backstage/catalog-model';
import type { FilterPredicate } from '@backstage/filter-predicates';
import { EntityTagFilter } from '@backstage/plugin-catalog-react';

export class WorkflowTagFilter extends EntityTagFilter {
  constructor(
    values: string[],
    private readonly includeUntagged: boolean,
  ) {
    super(values);
  }

  filterEntity(entity: Entity): boolean {
    if (!this.includeUntagged) return super.filterEntity(entity);
    return (
      !entity.metadata.tags?.length ||
      (this.values.length > 0 && super.filterEntity(entity))
    );
  }

  getCatalogQuery(): FilterPredicate | undefined {
    const tagged = super.getCatalogQuery();
    if (!this.includeUntagged) return tagged;
    // The catalog creates no tag index rows for either missing or empty arrays.
    const untagged: FilterPredicate = { 'metadata.tags': { $exists: false } };
    return tagged ? { $any: [tagged, untagged] } : untagged;
  }
}
